import React, { useState } from 'react'
import axios from 'axios'
import { images } from '../../constants'
import './login-page.css'
import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import translationEN from "../../constants/locales/en/translation.json";
import translationID from "../../constants/locales/id/translation.json";
import { useForm } from "react-hook-form";

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('lang') || 'en',
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

function LoginPage() {
  const [setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isloading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const onSubmit = async  (formData) => {
    setIsLoading(true);
    try {
      const response = await axios.post('https://backend2.senarai-app.com/login', {
        email: formData.email,
        password: formData.password
      }, {
        headers: {
          'Content-Type': 'application/json',
        }
      })
      localStorage.setItem('token', response.data.token);
      if(response.data.language_english === false) {
        localStorage.setItem('lang', 'id');
      } else {
        localStorage.setItem('lang', 'en');
      }
      window.location.href = '/history';
    } catch (error) {
      if (error.response?.data.detail.status_code === 401) {
        setErrorMessage(t("login_401"));
      } 
      else if (error.response?.data.detail.status_code === 404) {
        setErrorMessage(t("login_404"));
      } else{
        setErrorMessage(error.response?.data.detail.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className='flex flex-col justify-center items-center'>
        <div className='mb-6 mt-12'>
          <a href='/landingpage'>
            <img
              src={images.senarai}
              alt="senarai"
              style={{height:40}}
            />
          </a>
        </div>

        <div className="w-full max-w-lg p-4 bg-white border border-gray-200 rounded-xl shadow-2xl shadow-slate-300 sm:p-6 md:p-8">
          <form className="space-y-6" onSubmit={handleSubmit(onSubmit)}>
            <h5 className="text-xl font-medium text-gray-900">{t("login_title")}</h5>
            <div>
              <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900">{t("your_email")}</label>
              <input
                type="email"
                name="email"
                id="email"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                placeholder="your@email.com"
                {...register("email", {
                  required: t("register_empty_email"),
                  pattern: {
                    value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                    message: t("register_invalid_email"),
                  },
                })}
              />
              {errors.email && (<h4 className="text-[13px] text-[#E91D25]">{errors.email.message}</h4>)}
            </div>
            <div>
              <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-900">{t("your_password")}</label>
              <div className="relative">
                <input
                    data-testid="toggle-password-input"
                    type={showPassword ? "text" : "password"}
                    name="password"
                    id="password"
                    onChange={(event) => setPassword(event.target.value)}
                    // value={password}
                    placeholder="••••••••"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    {...register("password", {
                      required: t("register_empty_password"),
                    })}
                  />
                <button
                  data-testid="toggle-password-button"
                  type="button"
                  className="absolute inset-y-0 right-0 px-3 py-1.5 text-sm text-gray-600 focus:outline-none"
                  onClick={togglePasswordVisibility}>
                  {showPassword ?
                    // hide
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" />
                    </svg>
                    :
                    // show
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                    </svg>
                  }
                </button>
              </div>
              {errors.password && <h4 className="text-[13px] text-[#E91D25]">{errors.password.message}</h4>}
              {errorMessage && <h4 className="text-[13px] text-[#E91D25]">{errorMessage}</h4>}
            </div>
            {!isloading && (
              <button
                type="submit"
                className="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
              >
                {t("login_button")}
              </button>
            )}
            {isloading && (
              <button
                disabled
                type="button"
                className="flex items-center justify-center w-full cursor-not-allowed text-white bg-blue-400 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 inline-flex items-center"
              >
                <svg
                  aria-hidden="true"
                  role="status"
                  className="inline w-4 h-4 me-3 text-white animate-spin"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
                  <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                </svg>
                {t("logging_in")}
              </button>
            )}
            <div className="text-sm font-medium text-gray-500">
            {t("dont_have_acc")} <a href="/register" className="text-blue-700 hover:underline">{t("signup_here")}</a>
            </div>
          </form>
        </div>
      </div>
  )
}

export default LoginPage